import * as ko from "knockout"

export class StylesViewModel {
    fontFamily: KnockoutObservable<string>;
    fontSize: KnockoutObservable<string>;
    color: KnockoutObservable<string>;
    isBold: KnockoutObservable<boolean>;
    isItalic: KnockoutObservable<boolean>;

    constructor() {
        this.fontFamily = ko.observable("Helvetica");
        this.fontSize = ko.observable("14px");
        this.color = ko.observable("#000000");
        this.isBold = ko.observable(false);
        this.isItalic = ko.observable(false);
    }

    public clone(): StylesViewModel {
        let ret = new StylesViewModel();

        ret.fontFamily(this.fontFamily());
        ret.fontSize(this.fontSize());
        ret.color(this.color());
        ret.isBold(this.isBold());
        ret.isItalic(this.isItalic());

        return ret;
    }
}


// WEBPACK FOOTER //
// ./code/elements/StylesViewModel.ts